import React from 'react';
import { useDispatch } from 'react-redux';
import PageFormContainer from 'components/settings/Pages/Forms/PageFormContainer';
import { useHistory } from 'react-router-dom';
import { createPage } from 'redux/actions/pagesActions';

const CreatePage = () => {
    const dispatch = useDispatch();
    const history = useHistory();

    const updateForm = (data) => {
        dispatch(createPage(data, history));
    };

    return (
        <PageFormContainer updateForm={updateForm} submitText={'Create Page'} />
    );
};

export default CreatePage;
